export const BUILDING_DESCRIPTION_STEP_IDS = ['ADDRESS', 'ROOF', 'HEATING', 'SANITARY', 'RENOVATIONS'] as const;

export type BuildingDescriptionStepId = (typeof BUILDING_DESCRIPTION_STEP_IDS)[number];

export const DEFAULT_BUILDING_DESCRIPTION_STEP_ID: BuildingDescriptionStepId = 'ADDRESS';

export const BUILDING_DESCRIPTION_STEP_PATHS = {
    ADDRESS: 'address',
    HEATING: 'heating',
    RENOVATIONS: 'renovations',
    ROOF: 'roof',
    SANITARY: 'sanitary',
} as const satisfies Record<BuildingDescriptionStepId, string>;

export type BuildingDescriptionStepPath =
    (typeof BUILDING_DESCRIPTION_STEP_PATHS)[BuildingDescriptionStepId];
